/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/8/2021
 * @Example
 */

import React, { useState } from 'react';
import { TextInput, Button, Modal, ModalHeader, ModalBody } from 'diginet-core-ui/components';
import Config from '../../../../config/index';

const W05F0005LocationModal = (props) => {
    const { onClose, onAddLocationNo } = props;
    const [LocationNo, setLocationNo] = useState('');
    const [LocationNoDes, setLocationNoDes] = useState('');

    const onSave = () => {
        onAddLocationNo({ LocationNo, LocationNoDes });
    }

    return (
        <Modal
            open={true}
            onClose={onClose}
            width={'50%'}
        >
            <ModalHeader title={Config.lang("Them_moi_lo")} />
            <ModalBody>
                <TextInput
                    label={Config.lang('Ma_lo')}
                    value={LocationNo}
                    onChange={e => setLocationNo(e.target.value)}
                />
                <TextInput
                    label={Config.lang('Ten_lo')}
                    value={LocationNoDes}
                    onChange={e => setLocationNoDes(e.target.value)}
                />
                <div className="text-center pull-right display_row align-center">
                    <Button viewType="filled" color='info' label={Config.lang("Dong_y")} disabled={!LocationNo || !LocationNoDes}
                        onClick={onSave} />
                    <Button viewType="filled" color='default' label={Config.lang("Dong1")} onClick={onClose} />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default W05F0005LocationModal;